import { Dictionary } from '@feedyou/schema'
import { useEffect } from 'react'
import _ from 'lodash'

import { useIsDebugEnabled } from './useIsDebugEnabled'
import { attachToWindow } from '../../../lib/window'

export const useWindowDebugParams = (params: Dictionary<number | string, any>) => {
  const isDebugEnabled = useIsDebugEnabled()

  useEffect(() => {
    if (isDebugEnabled) {
      attachToWindow(params)
    } else {
      attachToWindow(_.mapValues(params, () => undefined))
    }
  })
}
